<template>
  <zh-table-page v-bind="{ title: '重点物料生命周期' }">
    <template #search>
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="表具编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="物料名称：" prop="materialName">
              <el-input
                v-model="searchData.materialName"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="物料类别：" prop="materialCategoryId">
              <el-tree-select
                filterable
                v-model="searchData.materialCategoryId"
                placeholder="请输入"
                :data="categoryList"
                :render-after-expand="false"
                :props="defaultProps"
                :check-strictly="true"
                node-key="id"
              />
              <!-- show-checkbox -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-row>
        <el-button type="primary" icon="Search" @click="getList()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      </el-row>

      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column
          label="序号"
          type="index"
          width="55"
          :index="indexMethod"
        />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            :width="item.width || ''"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleLifecycle(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <Lifecycle ref="lifecycleRef" />
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import useStashTable from "./hooks/useStashTable";
import Lifecycle from "./lifecycle.vue";
import useCateGoryList from "../../hooks/useCategoryList";

const { categoryList } = useCateGoryList();

const {
  searchRef,
  searchData,
  tableLoading,
  columns,
  tableData,
  pages,
  lifecycleRef,
  indexMethod,
  getList,
  handleSizeChange,
  handleCurrentChange,
  handleReset,
  handleLifecycle,
} = useStashTable();

const defaultProps = {
  label: "node",
  disabled: (data) => {
    return data.parentId == "0";
  },
};

onMounted(() => {
  getList();
});
</script>

<style scoped></style>
